const SKILLS = [
  {
    title: "Programming",
    icon: "./assets/images/img5.png",
    skills: [
      { skill: "CPP", percentage: "80%" },
      { skill: "Java", percentage: "95%" },
      { skill: "Python", percentage: "80%" },
      { skill: "JS", percentage: "70%" },
    ],
  },
  {
    title: "Frontend",
    icon: "./assets/images/img1.png",
    skills: [
      { skill: "HTML5", percentage: "80%" },
      { skill: "CSS3", percentage: "75%" },
      { skill: "React.js", percentage: "70%" },     
      { skill: "Bootstrap", percentage: "75%" },
    ],  
  },
  {
    title: "Backend",
    icon: "./assets/images/img2.png",
    skills: [
      { skill: "Node.js", percentage: "65%" },
      { skill: "Express.js", percentage: "55%" },
      
      { skill: "Next.js", percentage: "40%" },
    ],
  },
  {
    title: "Database",
    icon: "./assets/images/img3.png",
    skills: [
      { skill: "MongoDB", percentage: "75%" },
      { skill: "Oracle", percentage: "70%" },
      { skill: "MySql", percentage: "90%" },
    ],
  },
  {
    title: "Tools",
    icon: "./assets/images/img4.png",
    skills: [
      { skill: "Git & Github", percentage: "80%" },
      { skill: "Visual Studio Code", percentage: "85%" },
      { skill: "Eclipse", percentage: "65%" },
      { skill: "XAMPP", percentage: "95%" },
    ],
  },
  {
    title: "Utilities",
    icon: "./assets/images/img6.png",
    skills: [
      { skill: "ShadCN", percentage: "10%" },
      { skill: "Font Awesome", percentage: "25%" },
      { skill: "Postman", percentage: "55%" }, 
    ],
  },
];

const ACHIEVEMENTS = [
  {
    id: 1,
    title: "150 km cycling and running fitness challenge",
    description: "Successfully completed a 150 km cycling and running fitness challenge in one month.",
    icon: "🏆🥇",
    category: "Academic",
    year: "2021"
},
  {
    id: 2,
    title: "Academic Excellence",
    description: "Maintained 8.58 CGPA in Bachelor of Business Administration in Computer Applications",
    icon: "🎓",
    category: "Academic",
    year: "2024"
  },
  {
    id: 3,
    title: "Full Stack Mastery",
    description: "Proficient in MERN stack development with 10+ projects completed",
    icon: "💻",
    category: "Technical",
    year: "2025"
  },
  {
    id: 4,
    title: "Problem Solver",
    description: "Solved 100+ coding challenges on various platforms",
    icon: "🧩",
    category: "Programming",
    year: "Current"
  },
 
];

const EDUCATION = [
  {
    id: 1,
    degree: "Master of Computer Applications",
    institution: "P.E.S's Modern College of Engineering",
    location: "Pune",
    duration: "2024-2026",
    // grade: "CGPA: 8.68 (FYMCA)",
    status: "current",
    description: "Specializing in advanced software development and emerging technologies"
  },
  {
    id: 2,
    degree: "Bachelor of Business Administration in Computer Applications",
    institution: "Indira college of commerce and science",
    location: "Pune",
    duration: "2021-2024",
    // grade: "72.60%",
    status: "completed",
    description: "Foundation in computer science with focus on programming and web development"
  },
  {
    id: 3,
    degree: "Higher Secondary Certificate",
    institution: " Yeshwant Mahavidyalaya ",
    location: "Nanded",
    duration: "2020-2021",
    // grade: "93.67%",
    status: "completed",
    description: "Commerce stream with Business Mathematics and Computer Applications."
  },
  {
    id: 4,
    degree: "Secondary School Certificate",
    institution: "Gujarati High School ",
    location: "Nanded",
    duration: "2018-2019",
    // grade: "84.20%",
    status: "completed",
    description: "Strong foundation in mathematics and sciences"
  }
];

export { SKILLS, ACHIEVEMENTS, EDUCATION }; 
 